import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const SESSION_CHECK_URL = '/api/session/check';
const showFriendlyErrMsg = ['Local', 'Dev', 'QA'];

export const sessionInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  // const sessionService = inject(SessionService);

  const isSessionCheckRequest = req.url.includes(SESSION_CHECK_URL);

  // // Fire a debounced session check using the service
  // if (!isSessionCheckRequest) {
  //   sessionService.renewSession().subscribe(); // safe: service handles debounce
  // }

  // const router = inject(Router);

  // const clone = req.clone({
  //   headers: req.headers.set('X-Requested-With', 'XMLHttpRequest'),
  // });
  const modifiedReq = isSessionCheckRequest
    ? req
    : req.clone({
        headers: req.headers.set('X-Requested-With', 'XMLHttpRequest'),
      });

  return next(modifiedReq).pipe(
    tap({
      error: (err: any) => {
        if (err instanceof HttpErrorResponse && [401, 404, 500].includes(err.status)) {
          const target = window.location.pathname;
          if (err.status === 401) {
            if (!isSessionCheckRequest) {
              // const returnUrl = window.location.pathname;
              console.warn('Session expired. Redirecting to login...');
              window.location.href = `/?target=${encodeURIComponent(target)}`;
              return false;
            }
          }
          if (err.error !== null && err.error?.redirect === 'false') return false;

          const errorPage = `/assets/errors/${err.status}.html`;
          const errorUrl =
            showFriendlyErrMsg.includes(environment.environmentName) && err.error ? `${errorPage}?err=${encodeURIComponent(err.error)}` : errorPage;

          window.location.replace(errorUrl);
          return true;
        }

        return false; // Handle other errors as needed
      },
    }),
  );
  // return next(clone).pipe(
  //   tap({
  //     error: (error) => {
  //       if (error instanceof HttpErrorResponse) {
  //         if (error.url?.includes('notFound')) {
  //           router.navigate(['/notFound']);
  //         }
  //         if (!error.url?.includes('/api/session')) {
  //           console.error('Error occurred:', error);
  //           switch (error.status) {
  //             case 401:
  //               // window.location.href = '/';
  //               const target = window.location.pathname; // Refers to the global window object
  //               window.location.href = `/?target=${encodeURIComponent(target)}`;
  //               break;
  //           }
  //         }
  //       }
  //     },
  //   }),
  // );
};
